import { createRoot } from 'react-dom/client'

/**
 * Mounts a React tree into a detached node, so the imperative APIs
 * (`message.success`, `Modal.confirm`, `notification.open`) can be called from
 * anywhere without a provider, exactly like antd's static methods.
 *
 * @param {(close: () => void) => React.ReactNode} render
 * @returns {{ destroy: () => void, update: (next: any) => void }}
 */
export const mountDetached = (render) => {
  const host = document.createElement('div')
  host.setAttribute('data-kit-imperative', '')
  document.body.appendChild(host)
  const root = createRoot(host)

  let destroyed = false

  const destroy = () => {
    if (destroyed) return
    destroyed = true
    // Unmount on a later tick: React forbids unmounting from inside a render.
    setTimeout(() => {
      root.unmount()
      host.remove()
    }, 0)
  }

  const update = (nextRender) => {
    if (destroyed) return
    root.render(nextRender(destroy))
  }

  root.render(render(destroy))

  return { destroy, update }
}

export default mountDetached
